import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-content-search',
  templateUrl: './content-search.component.html',
  styleUrls: ['./content-search.component.scss'],
  animations: [
    trigger('slideInOut', [
      state(
        'true',
        style({
          overflow: 'hidden',
          height: '*',
          width: '300px'
        })
      ),
      state(
        'false',
        style({
          opacity: '0',
          overflow: 'hidden',
          height: '*',
          width: '0px'
        })
      ),
      transition('true => false', animate('400ms ease-in-out')),
      transition('false => true', animate('400ms ease-in-out'))
    ])
  ]
})
export class ContentSearchComponent {
  showInput = false;
  value = '';
  form: FormGroup = new FormGroup({
    value: new FormControl('', [Validators.required, Validators.minLength(3)])
  });

  constructor(private router: Router) {}

  expandInput() {
    this.showInput = true;
  }
  closeInput() {
    this.showInput = false;
    this.clearInput();
  }
  clearInput() {
    this.form.controls.value.setValue('');
  }
  search() {
    if (this.form.valid) {
      this.router.navigateByUrl('/search/' + this.form.controls.value.value);
    }
  }
}
